import { useLayout } from 'context'
import React, { useEffect } from 'react'

interface TitleProps {
  children: string
}

export default function Title({ children }: TitleProps) {
  const layout = useLayout()

  useEffect(() => {
    layout.setTitle(children)

    return () => {
      layout.setTitle('')
    }
  }, [children, layout])

  return <React.Fragment />
}
